module.exports = __webpack_public_path__ + "img/copy_btn.0e57daa0.png";